import SHA256 from 'crypto-js/sha256';
import { testerEmails } from './constants';
import ReactGA from 'react-ga4';

export const hashStringWithSHA256 = (input: string): string =>
  SHA256(input).toString();

export const isTesterEmail = (email: string): boolean =>
  testerEmails.includes(email);

export const trackPageView = (location: string, title: string) => {
  ReactGA.event('page_view', {
    page_location: location,
    page_title: title
  });
};
